export default {
    namespaced: true,
    state: {
        term_softs: [
            '单网盘检索工具',
            '多网盘检索工具',
            '多网盘检索工具精简版',
            '网页聊天机器人',
            '数据处理工具箱',
            '批量解压转换',
            '批量解压',
            '网页版图书信息检索',
        ],
        fen_softs: [
            '小饿软件代理端',
            '自助解封',
            'IP工具',
            '书签获取工具',
            '批量获取封面',
            '网盘检索工具出租版',
        ]
    }
}